import React, { ReactElement, useEffect, useState } from 'react';
import { formatBigNumber } from '../../../../common/utils/utils';
import {
  useGetUserCoinsMutation,
  useGetUserInfoQuery,
} from '../../../../services/api/apiProvider';
import { ResponseUserDiamondCoin } from '../../../../services/api/models/response/responseUserDiamondCoin';
import diamond from '../../../../assets/png/diamond.png';
import verifiedIcon from '../../../../assets/svg/officialliver_icon.svg';
import noAvatar from '../../../../assets/png/mitouroku_icon.png';
import './WalletUserInfo.scss';

export const WalletUserInfo = (): ReactElement => {
  const { data: user } = useGetUserInfoQuery();
  const [userCoin, setUserCoin] = useState<ResponseUserDiamondCoin>();
  const [getUserCoin] = useGetUserCoinsMutation();

  useEffect(() => {
    getUserCoin()
      .unwrap()
      .then((response) => {
        setUserCoin(response);
      });
  }, []);

  return (
    <div className="user-info">
      <div className="user-info__top">
        <img
          src={user?.picture.uri || noAvatar}
          alt=""
          className="user-info__avatar"
        />
        <span className="user-info__standout">
          <em className="user-info__user-level">Lv.{user?.level}</em>
          <span className="user-info__user-name">{user?.loginId}</span>
          <img
            src={verifiedIcon}
            alt="認証済み"
            className="user-info__ceritified-icon"
            hidden={!user?.isCertifiedLiver}
          />
        </span>
      </div>
      <div className="user-info__bottom">
        <div className="user-info__diamond">
          <img
            src={diamond}
            width="45"
            alt="経常収支"
            className="user-info__diamond-icon"
          />
          <span className="user-info__diamond-amount">
            {formatBigNumber(userCoin?.coin || 0)}
          </span>
        </div>
        <dl className="user-info__dl">
          <dt className="user-info__dt">有償ダイヤ</dt>
          <dd className="user-info__dd">
            {formatBigNumber(userCoin?.detail.coin || 0)}
          </dd>
          <dt className="user-info__dt">プレゼントダイヤ</dt>
          <dd className="user-info__dd">
            {formatBigNumber(userCoin?.detail.freeCoin || 0)}
          </dd>
        </dl>
      </div>
    </div>
  );
};
